import { ListBullets, SquaresFour } from 'phosphor-react';
import React from 'react';
import Placeholder from '../assets/images/imagePlaceholder.png';
import {
  GET_AUTOGENERATE_BY_COLLECTIONS,
  GET_AUTOGENERATE_BY_TAGS,
  GET_AUTOGENERATE_BY_TOPIC
} from '../modules/pages/graphql/Queries';
/* ROUTERS  */
export const ROUTES = {
  MAIN: '/',
  LOGOUT: '/logout',
  LOGIN: '/login',
  FORGET_PASSWORD: '/forgot-password',
  RESET: '/reset-password',
  VERIFY: '/verify',
  AUTHENTICATION: '/authentication',
  PROFILE: '/profile',
  IMAGES: '/images',
  VIDEOS: '/videos',
  DOCUMENT: '/document',
  AUDIO: '/audio',
  // TEXT: '/text', // NOTE: Commented out for CVP 7.2 fixes - BBART-2082
  // See: https://app.clickup.com/t/606124/BBART-2082
  ICONS: '/icons',
  TOPICS: '/topics',
  COLLECTIONS: '/collections',
  TAGS: '/tags',
  VIDEOS_MODULE: '/video-module',
  PAGES_MODULE: '/pages-module',
  MENUS: '/menus',
  UI_LABELS: '/ui-labels',
  PAGE_TEMPLATES: '/page-templates',
  USERS: '/users',
  DONATIONS: '/donations',
  EXPORT_JOBS: '/export-jobs',
  IMPORT_JOBS: '/import-jobs',
  DASHBOARD: '/dashboard-analytics',
  PODCAST_MODULE: '/podcast-module',
  ADMIN_USERS: '/admin-users',
  ROLES: '/roles',
  WORKSPACE_USERS: '/workspace-users',
  NO_ACCESS: '/no-access',
  PLATFORMS: '/platforms',
  COMPONENTS: '/components',
  APPS: '/apps',
  WORKSPACES: '/workspaces',
  SUBSCRIPTION_PLANS: '/subscription-plans',
  DASHBOARD_LANDING: '/dashboard',
  FORMS: '/form-module',
  ARTICLES_MODULE: '/article-module',
  SET_PASSWORD: '/set-password'
};

/*  Modules */
export const MODULES = {
  PROFILE: 'PROFILE',
  ASSETS: 'ASSETS',
  LABELS: 'LABELS',
  IMAGES: 'IMAGES',
  VIDEOS: 'VIDEOS',
  DOCUMENT: 'DOCUMENT',
  AUDIO: 'AUDIO',
  TEXT: 'TEXT',
  ICONS: 'ICONS',
  TOPICS: 'TOPICS',
  PAGES: 'PAGES',
  COLLECTIONS: 'COLLECTIONS',
  TAGS: 'TAGS',
  MENUS: 'MENUS',
  UI_LABELS: 'UI LABELS',
  USERS: 'USERS',
  DONATIONS: 'DONATIONS',
  EXPORT_JOBS: 'EXPORT JOBS',
  IMPORT_JOBS: 'IMPORT JOBS',
  DASHBOARD: 'DASHBOARD',
  PODCAST: 'PODCAST',
  CONTENT_UNITS: 'CONTENT UNITS',
  REPORTS: 'REPORTS',
  UI_CONFIGURATION: 'UI CONFIGURATION',
  ADMINS: 'ADMINS',
  ROLES: 'ROLES',
  PLATFORMS: 'PLATFORMS',
  WORKSPACE_USERS: 'WS USERS',
  APPS: 'APPS',
  WORKSPACES: 'WORKSPACES',
  SUBSCRIPTION_PLANS: 'SUBSCRIPTION PLANS',
  APP_SETTINGS: 'APP SETTINGS',
  WORKSPACE_SETTINGS: 'WS SETTINGS',
  FORMS: 'FORMS',
  ARTICLES: 'ARTICLES',
  PAGE_TEMPLATES: 'PAGE TEMPLATES'
};

export const ASSET_CATEGORY = {
  VIDEO: 'VIDEO',
  TEXT: 'TEXT',
  AUDIO: 'AUDIO',
  IMAGE: 'IMAGE',
  DOCUMENT: 'DOCUMENT',
  ICON: 'ICON'
};

/* Authentication */
export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER = 'USER';

/* Workspace */
export const WORKSPACE = 'WORKSPACE';
export const APP = 'APP';

export const ROLES = {
  SUPER_ADMIN: 'Super admin',
  ADMIN: 'Admin'
};

export const ROLE_KEYS = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  USER: 'USER',
  WORKSPACE_USER: 'WORKSPACE_USER'
};

/* Date and time */
export const defaultDateFormat = 'MM/DD/YYYY';
export const defaultDateFormatWithTime = 'MM/DD/YYYY hh:mm:ss';

export const VIDEOS = [
  {
    id: 1,
    title: 'Elephant Dream',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://video3cdn.cappital.co/streaming-playlists/hls/19189e03-b90f-4d0e-991d-4c8aee34a5e9/5f44e513-d398-4f93-8e8a-074d788fc0fc-master.m3u8'
  },
  {
    id: 2,
    title: 'Big Buck Bunny',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://peertubetv.s3.eu-central-1.wasabisys.com/streaming-playlists/hls/f37656eb-be47-4289-bda3-5851ca40a501/59755baf-d2b4-461d-9333-12faa7908924-master.m3u8'
  },
  {
    id: 3,
    title: 'For Bigger Escape',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://video3cdn.cappital.co/streaming-playlists/hls/65fb42ad-7dd4-410f-8a28-63fc8f6111e7/2067a88e-baa9-4dfe-800e-3bb3ef8ae688-master.m3u8'
  },
  {
    id: 4,
    title: 'For Bigger Joyrides',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://video3cdn.cappital.co/streaming-playlists/hls/5f5f20b3-5f39-425e-bca5-d8af2a8c14d4/13338140-c8e1-4cf0-8641-7a9f23b9881d-master.m3u8'
  },
  {
    id: 5,
    title: 'Elephant Dream',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://video3cdn.cappital.co/streaming-playlists/hls/5f5f20b3-5f39-425e-bca5-d8af2a8c14d4/13338140-c8e1-4cf0-8641-7a9f23b9881d-master.m3u8'
  },
  {
    id: 6,
    title: 'Big Buck Bunny',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://peertubetv.s3.eu-central-1.wasabisys.com/streaming-playlists/hls/f37656eb-be47-4289-bda3-5851ca40a501/59755baf-d2b4-461d-9333-12faa7908924-master.m3u8'
  },
  {
    id: 7,
    title: 'For Bigger Escape',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://video3cdn.cappital.co/streaming-playlists/hls/65fb42ad-7dd4-410f-8a28-63fc8f6111e7/2067a88e-baa9-4dfe-800e-3bb3ef8ae688-master.m3u8'
  },
  {
    id: 8,
    title: 'For Bigger Joyrides',
    thumb: Placeholder,
    tracks: [
      {
        kind: 'subtitles',
        label: 'English',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/76487ab0-7499-419b-80af-03b662cdbc93-en.vtt',
        srcLang: 'en',
        default: false
      },
      {
        kind: 'subtitles',
        label: 'French',
        src:
          'https://video3.cappital.co/lazy-static/video-captions/91677363-5e15-44f4-bd50-76b6d9fc056c-de.vtt',
        srcLang: 'de',
        default: false
      },
      {
        kind: 'chapters',
        src:
          'https://s3.amazonaws.com/demo.jwplayer.com/text-tracks/assets/chapters.vtt',
        default: true
      }
    ],
    url:
      'https://video3cdn.cappital.co/streaming-playlists/hls/5f5f20b3-5f39-425e-bca5-d8af2a8c14d4/13338140-c8e1-4cf0-8641-7a9f23b9881d-master.m3u8'
  }
];
// export const VIDEO_URL =
//   'https://peertubetv.s3.eu-central-1.wasabisys.com/streaming-playlists/hls/f37656eb-be47-4289-bda3-5851ca40a501/59755baf-d2b4-461d-9333-12faa7908924-master.m3u8';

export const SHARE_URL = 'http://localhost:3000/video-player';

export const TRACK_KIND = {
  SUBTITLES: 'subtitles',
  CAPTIONS: 'captions',
  CHAPTERS: 'chapters'
};

export const TRACK_MODE = {
  SHOWING: 'showing',
  DISABLED: 'disabled'
};

export const PLAYBACK_RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

export const defaultSubtitle = 'English';

export const REGEX = {
  NAME: /^[a-z ,.'-]+$/i,
  ZIPCODE: /^[0-9]{5,6}$/,
  CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  WEB_URL: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
  // eslint-disable-next-line no-useless-escape
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};:"\\|,.<>\/?~]{8,64}$/,
  PHONE: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  EMAIL: /^(([^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+(\.[^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  AMOUNT: /^\d+$|^\d+\.\d*$/,
  OPTIONALNEGATIVEAMOUNT: /^[-]?\d+$|^[-]?\d+\.\d*$/,
  NUMBER: /^\d+$/,
  COUNTRY_CODE_PHONE: /^[0-9]{7,12}$/,
  KEY_VALUE: /^[A-Z0-9_]*$/,
  USERNAME: /^[a-z0-9]+$/,
  DOMAIN: /^[a-z-]+$/
};

export const LIMIT = 15;
export const ARTICLE_LIST_MIN_LIMIT = 1;
export const ARTICLE_LIST_MAX_LIMIT = 30;
export const SCROLL_PERCENT = 0.85;

export const SORT_FIELD = [
  { name: 'Created At', value: 'createdAt' },
  { name: 'Title', value: 'title' }
];
export const PAGES_SORT_FIELD = [
  { name: 'Created At', value: 'createdAt' },
  { name: 'Title', value: 'title' },
  { name: 'Status', value: 'status' }
];
export const USERS_SORT_FIELD = [
  { name: 'Created At', value: 'createdAt' },
  { name: 'First Name', value: 'firstName' },
  { name: 'Last Name', value: 'lastName' },
  { name: 'Email', value: 'email' }
];
export const VIDEO_PLATFORMS_SORT_FIELD = [
  { name: 'Created At', value: 'createdAt' },
  { name: 'Name', value: 'name' }
];

export const TAGS_SORT_FIELD = [
  { name: 'Created At', value: 'createdAt' },
  { name: 'Name', value: 'name' }
];
export const TOPICS_SORT_FIELD = [
  ...TAGS_SORT_FIELD,
  { name: 'Key', value: 'key' }
];

export const ROLES_SORT_FIELD = [{ name: 'Created At', value: 'createdAt' }];

export const SUBSCRIPTION_SORT_FIELD = [
  ...TOPICS_SORT_FIELD,
  { name: 'Order', value: 'order' }
];

export const ORDER = [
  { name: 'Ascending', value: 'ASC' },
  { name: 'Descending', value: 'DESC' }
];
export const CREDIT_TYPE = [
  { name: 'Cast', value: 'CAST' },
  { name: 'Crew', value: 'CREW' }
];

export const GENDER = [
  { name: 'Female', value: 'FEMALE' },
  { name: 'Male', value: 'MALE' },
  { name: 'Other', value: 'OTHER' }
];

export const USER_ROLES = [
  {
    label: 'User',
    value: 'USER'
  },
  {
    label: 'Admin',
    value: 'ADMIN'
  },
  {
    label: 'Super Admin',
    value: 'SUPER_ADMIN'
  },
  {
    label: 'Workspace User',
    value: 'WORKSPACE_USER'
  }
];

export const ERROR_PAGE_TITLE = 'Oops! An error occurred!';
export const ERROR_PAGE_SUBTITLE =
  'Something is broken. Please let us know what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.';

export const GUTTER_VARIATIONS = { xs: 16, sm: 16, md: 24, lg: 32 };

export const BREAKPOINTS = {
  mobile: 550,
  tablet: 767,
  desktop: 1000,
  hd: 1200
};

export const STATUS_TYPES = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED'
};

export const STATUS_SCHEDULED = 'SCHEDULED';

export const STATUS_OPTIONS = [
  { name: 'Draft', value: STATUS_TYPES.DRAFT },
  { name: 'Published', value: STATUS_TYPES.PUBLISHED }
];

export const ARTICLE_ACTION_TYPE = [
  { name: 'Load More', value: 'LOAD_MORE' },
  { name: 'View All', value: 'VIEW_ALL' }
];

export const UNPUBLISHED_STATUS = {
  name: 'Unlisted',
  value: STATUS_TYPES.UNPUBLISHED
};

export const LIST_TYPES = {
  GRID: 'grid',
  TABLE: 'table'
};

export const LIST_OPTIONS = [
  {
    name: 'Grid view',
    icon: <SquaresFour size={32} />,
    value: LIST_TYPES.GRID
  },
  {
    name: 'List view',
    icon: <ListBullets size={32} />,
    value: LIST_TYPES.TABLE
  }
];

export const PAGE_MODULE_TYPES = {
  VIDEO_CONTINUE_WATCHING_CAROUSEL: 'VIDEO_CONTINUE_WATCHING_CAROUSEL',
  VIDEO_CAROUSEL: 'VIDEO_CAROUSEL',
  VIDEO_LIST: 'VIDEO_LIST',
  VIDEO_GRID: 'VIDEO_GRID',
  FEATURED_VIDEO: 'FEATURED_VIDEO',
  FEATURED_VIDEO_SLIDER: 'FEATURED_VIDEO_SLIDER',
  COLLECTION_CAROUSEL: 'COLLECTION_CAROUSEL',
  COLLECTION_LIST: 'COLLECTION_LIST',
  COLLECTION_GRID: 'COLLECTION_GRID',
  FEATURED_COLLECTION: 'FEATURED_COLLECTION'
};

export const AUTO_GENERATED_SORT_BY_TYPES = {
  RECENT: 'RECENT',
  RANDOM: 'RANDOM',
  VIEWS: 'VIEWS',
  FORM_COMPLETION: 'FORM_COMPLETION',
  PLAYS: 'PLAYS'
};

export const MODULE_TYPES = {
  SETTINGS: 'SETTINGS',
  ADD: 'ADD',
  VIDEO_CONTINUE_WATCHING_CAROUSEL: 'VIDEO_CONTINUE_WATCHING_CAROUSEL',
  VIDEO_CAROUSEL: 'VIDEO_CAROUSEL',
  VIDEO_LIST: 'VIDEO_LIST',
  VIDEO_GRID: 'VIDEO_GRID',
  VIDEO_PLAYER: 'VIDEO_PLAYER',
  FEATURED_VIDEO: 'FEATURED_VIDEO',
  FEATURED_VIDEO_SLIDER: 'FEATURED_VIDEO_SLIDER',
  PODCAST_LIST: 'PODCAST_LIST',
  PODCAST_PLAYER: 'PODCAST_PLAYER',
  COLLECTION_CAROUSEL: 'COLLECTION_CAROUSEL',
  COLLECTION_LIST: 'COLLECTION_LIST',
  COLLECTION_GRID: 'COLLECTION_GRID',
  FEATURED_COLLECTION: 'FEATURED_COLLECTION',
  FEATURED_COLLECTION_SLIDER: 'FEATURED_COLLECTION_SLIDER',
  COLLECTION_PILL_CAROUSEL: 'COLLECTION_PILL_CAROUSEL',
  COLLECTION_DETAIL: 'COLLECTION_DETAIL',
  HTML_TEXT_BLOCK: 'HTML_TEXT_BLOCK',
  TOPIC_CAROUSEL: 'TOPIC_CAROUSEL',
  TOPIC_GRID: 'TOPIC_GRID',
  TOPIC_LIST: 'TOPIC_LIST',
  FEATURED_TOPIC: 'FEATURED_TOPIC',
  TAG_CAROUSEL: 'TAG_CAROUSEL',
  TAG_CLOUD: 'TAG_CLOUD',
  FEATURED_TAG: 'FEATURED_TAG',
  CTA_BLOCK: 'CTA_BLOCK',
  CTA_BANNER: 'CTA_BANNER',
  DONATION: 'DONATION',
  CTA_BANNER_WITH_TEXT: 'CTA_BANNER_WITH_TEXT',
  HERO: 'HERO',
  INFORMATION: 'INFORMATION',
  FAQ: 'FAQ',
  SPACER: 'SPACER',
  FORM_CAROUSEL: 'FORM_CAROUSEL',
  FORM_DISPLAY: 'FORM_DISPLAY',
  SUBSCRIPTION_HEADER: 'SUBSCRIPTION_HEADER',
  SUBSCRIPTION_BLOCK: 'SUBSCRIPTION_BLOCK',
  SUBSCRIPTION_LIST: 'SUBSCRIPTION_LIST',
  ARTICLE_LIST: 'ARTICLE_LIST',
  CTA_BUTTON_LIST: 'CTA_BUTTON_LIST',
  NOTIFICATION_PREFERENCES_LIST: 'NOTIFICATION_PREFERENCES_LIST',
  DOWNLOAD_APP: 'DOWNLOAD_APP',
  IMAGE_CAROUSEL: 'IMAGE_CAROUSEL',
  ARTICLE_LIST_V2: 'ARTICLE_LIST_V2'
};

export const DAYS = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday'
};

export const TABLE_LOCATION_TYPES = {
  PHYSICAL: 'Physical',
  REMOTE: 'Online'
};

export const THEMES = {
  NEUTRAL_300: 'NEUTRAL_300',
  NEUTRAL_400: 'NEUTRAL_400',
  NEUTRAL_900: 'NEUTRAL_900',
  NEUTRAL_1000: 'NEUTRAL_1000',
  BLUE: 'BLUE',
  BLUE_SHADE: 'BLUE_SHADE',
  BLUE_TINT: 'BLUE_TINT',
  MOSS: 'MOSS',
  MOSS_TINT: 'MOSS_TINT',
  YELLOW: 'YELLOW'
};

export const THEME_PICKER_COLORS = {
  [THEMES.NEUTRAL_300]: {
    backgroundColor: 'bg-n-300',
    textLight: false
  },
  [THEMES.NEUTRAL_400]: {
    backgroundColor: 'bg-n-400',
    textLight: false
  },
  [THEMES.NEUTRAL_900]: {
    backgroundColor: 'bg-n-900',
    textLight: true
  },
  [THEMES.NEUTRAL_1000]: {
    backgroundColor: 'bg-n-1000',
    textLight: true
  },
  [THEMES.BLUE]: {
    backgroundColor: 'bg-blue-2',
    textLight: false
  },
  [THEMES.BLUE_SHADE]: {
    backgroundColor: 'bg-blue-3',
    textLight: true
  },
  [THEMES.BLUE_TINT]: {
    backgroundColor: 'bg-blue',
    textLight: false
  },
  [THEMES.MOSS]: {
    backgroundColor: 'bg-moss-2',
    textLight: false
  },
  [THEMES.MOSS_TINT]: {
    backgroundColor: 'bg-moss',
    textLight: false
  },
  [THEMES.YELLOW]: {
    backgroundColor: 'bg-yellow-2',
    textLight: false
  }
};

export const ALIGNMENTS = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
};

export const PAYMENT_STATUS = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  FAILED: 'FAILED'
};

export const SUBSCRIPTION_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  PAYMENT_DUE: 'PAYMENT_DUE'
};

export const DONATION_TYPES = {
  ONE_TIME: 'ONE_TIME',
  MONTHLY: 'MONTHLY',
  ANNUALLY: 'ANNUALLY'
};

export const STATUS_COLORS = {
  PENDING: '#0958D9',
  PROCESSING: '#FAAD14',
  PAYMENT_DUE: '#FAAD14',
  EXPORTING: '#FAAD14',
  ERRORED: '#FF4D4F',
  FAILED: '#FF4D4F',
  CANCELLED: '#FF4D4F',
  READY: '#52C41A',
  SUCCESS: '#52C41A',
  ACTIVE: '#52C41A',
  COMPLETED: '#52C41A'
};

export const DATA_COLLECTION_TYPE_KEYS = {
  NEWS_LETTER: 'NEWS_LETTER'
};

export const STATIC_PAGES = [
  { label: 'Topics', value: 'topics' },
  { label: 'Tags', value: 'tags' },
  { label: 'Collections', value: 'collections' },
  { label: 'Videos', value: 'videos' },
  { label: 'Search', value: 'search' },
  { label: 'Manage Donation', value: 'manage-donation' },
  { label: 'Conversations', value: 'conversations' },
  { label: 'My Conversations', value: 'conversations/my-conversations' },
  { label: 'My Playlists', value: 'playlists' },
  { label: 'Account Settings', value: 'settings' },
  { label: 'Login', value: 'login' },
  { label: 'Signup', value: 'signup' },
  { label: 'Reset Password', value: 'reset-password' },
  { label: 'Change Password', value: 'change-password' },
  { label: 'Terms & Conditions', value: 'terms-and-conditions' },
  { label: 'Privacy Policy', value: 'privacy-policy' }
];

export const RATIOS = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
};

export const SPACER_OPTIONS = [
  { label: '0px', value: 's-0' },
  { label: '5px', value: 's-5' },
  { label: '10px', value: 's-10' },
  { label: '15px', value: 's-15' },
  { label: '20px', value: 's-20' },
  { label: '25px', value: 's-25' },
  { label: '30px', value: 's-30' },
  { label: '35px', value: 's-35' },
  { label: '40px', value: 's-40' },
  { label: '45px', value: 's-45' },
  { label: '50px', value: 's-50' }
];

export const WEB_ROUTES = {
  COLLECTION: '/collections',
  TAG: '/tags',
  TOPIC: '/topics',
  CUSTOM: '',
  VIDEO: '/videos',
  FORM: '/forms',
  PODCAST: '/podcasts'
};

export const TEMPLATE_OPTION = {
  label: '*',
  value: '*'
};

export const DATE_FORMAT = 'M/D/YY';
export const FULL_DATE_TIME_FORMAT = 'LT L';
export const IMPORT_VIDEO_DATE_FORMAT = 'll';

export const EXPORT_JOB_TYPES = {
  USER: 'USER',
  ADMIN_USER: 'ADMIN_USER',
  FORM_RESPONSE: 'FORM_RESPONSE',
  UI_LABEL: 'UI_LABEL'
};

export const TEXT_ALIGNMENTS = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT',
  JUSTIFY: 'JUSTIFY'
};

export const TEXT_ALIGNMENTS_CLASS = {
  [TEXT_ALIGNMENTS.LEFT]: 'text-left',
  [TEXT_ALIGNMENTS.CENTER]: 'text-center',
  [TEXT_ALIGNMENTS.RIGHT]: 'text-right',
  [TEXT_ALIGNMENTS.JUSTIFY]: 'text-justify'
};

export const GRID_TYPE = {
  BUTTON: 'BUTTON',
  CARD: 'CARD'
};

export const PAGE_TYPES = {
  COLLECTION: 'COLLECTION',
  TAG: 'TAG',
  TOPIC: 'TOPIC',
  VIDEO: 'VIDEO',
  CUSTOM: 'CUSTOM',
  PODCAST: 'PODCAST',
  STATIC: 'STATIC',
  FORM: 'FORM',
  ARTICLE: 'ARTICLE'
};

export const PAGE_TYPES_OPTIONS = [
  { label: 'Collection', value: PAGE_TYPES.COLLECTION },
  { label: 'Tag', value: PAGE_TYPES.TAG },
  { label: 'Topic', value: PAGE_TYPES.TOPIC },
  { label: 'Video', value: PAGE_TYPES.VIDEO },
  { label: 'Custom', value: PAGE_TYPES.CUSTOM },
  { label: 'Static', value: PAGE_TYPES.STATIC },
  { label: 'Podcast', value: PAGE_TYPES.PODCAST },
  { label: 'Form', value: PAGE_TYPES.FORM }
];

export const CLOUD_FRONT_CACHE_KEYS = {
  MENU: 'MENU',
  UI_LABELS: 'UI_LABELS',
  OG_IMAGES: 'OG_IMAGES'
};

export const EDITOR_MODULES = {
  toolbar: [
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'link'],
    [
      { align: [] },
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ]
  ]
};

export const VIDEO_RESOURCES_TYPES = {
  QUESTIONS: 'questions',
  LINKS: 'links'
};

export const PAGE_TYPE_LABELS = {
  COLLECTION: 'COLLECTION',
  TAG: 'TAG',
  TOPIC: 'TOPIC',
  VIDEO: 'VIDEO',
  CUSTOM: 'CUSTOM',
  PODCAST: 'PODCAST',
  FORM: 'FORM'
};

export const UI_LABEL_TYPES = {
  STRING: 'STRING',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  VIDEO_CAROUSEL: 'VIDEO_CAROUSEL',
  HTML: 'HTML'
};

export const UI_LABEL_TYPES_OPTIONS = [
  {
    label: 'String',
    value: UI_LABEL_TYPES.STRING
  },
  { label: 'Image', value: UI_LABEL_TYPES.IMAGE },
  { label: 'Video', value: UI_LABEL_TYPES.VIDEO },
  { label: 'Video Carousel', value: UI_LABEL_TYPES.VIDEO_CAROUSEL },
  { label: 'Html', value: UI_LABEL_TYPES.HTML }
];

export const UI_LABEL_VIDEO_SOURCE_TYPE = {
  ASSET: 'ASSET',
  CONTENT_UNIT: 'CONTENT_UNIT'
};

export const UI_LABEL_VIDEO_SOURCE_TYPE_OPTIONS = [
  { label: 'Asset', value: UI_LABEL_VIDEO_SOURCE_TYPE.ASSET },
  { label: 'Content Unit', value: UI_LABEL_VIDEO_SOURCE_TYPE.CONTENT_UNIT }
];

export const MAX_UI_LABEL_VIDEO_CAROUSEL_ITEMS = 10;

export const AUDIO_SERVICE_TYPES = {
  MANUAL: 'MANUAL',
  PEERTUBE: 'PEERTUBE'
};

export const allowedAudio = ['mp3'];
export const allowedImagesAll = ['jpg', 'jpeg', 'png', 'heic', 'gif'];
export const allowedImages = ['jpg', 'jpeg', 'png'];

export const AUTO_GENERATED_TYPES = {
  TOPIC: 'TOPIC',
  TAG: 'TAG',
  COLLECTION: 'COLLECTION'
};

export const AUTO_GENERATED_OPTIONS = [
  {
    label: 'Topic',
    value: AUTO_GENERATED_TYPES.TOPIC
  },
  {
    label: 'Tag',
    value: AUTO_GENERATED_TYPES.TAG
  },
  {
    label: 'Collection',
    value: AUTO_GENERATED_TYPES.COLLECTION
  }
];

export const AUTO_GENERATED_SORT_BY_OPTIONS = [
  { label: 'Recent', value: AUTO_GENERATED_SORT_BY_TYPES.RECENT },
  { label: 'Random', value: AUTO_GENERATED_SORT_BY_TYPES.RANDOM },
  { label: 'Views', value: AUTO_GENERATED_SORT_BY_TYPES.VIEWS }
];

export const getAutoGeneratedByIdProps = {
  [AUTO_GENERATED_TYPES.TOPIC]: {
    query: GET_AUTOGENERATE_BY_TOPIC,
    dataSelector: (data) =>
      data?.topicsAdmin?.topics?.map(({ id, name }) => ({
        label: name,
        value: id
      })) || [],
    countSelector: (data) => data?.topicsAdmin?.count ?? 0,
    keys: {
      data: 'topicsAdmin',
      records: 'topics',
      count: 'count'
    }
  },
  [AUTO_GENERATED_TYPES.TAG]: {
    query: GET_AUTOGENERATE_BY_TAGS,
    dataSelector: (data) =>
      data?.tagsAdmin?.tags?.map(({ id, name }) => ({
        label: name,
        value: id
      })) || [],
    countSelector: (data) => data?.tagsAdmin?.count ?? 0,
    keys: {
      data: 'tagsAdmin',
      records: 'tags',
      count: 'count'
    }
  },
  [AUTO_GENERATED_TYPES.COLLECTION]: {
    query: GET_AUTOGENERATE_BY_COLLECTIONS,
    dataSelector: (data) =>
      data?.collectionsAdmin?.collections?.map(({ id, title }) => ({
        label: title,
        value: id
      })) || [],
    countSelector: (data) => data?.collectionsAdmin?.count ?? 0,
    keys: {
      data: 'collectionsAdmin',
      records: 'collections',
      count: 'count'
    }
  }
};

export const getAutoGenerateByDataValue = {
  [AUTO_GENERATED_TYPES.TOPIC]: ({ topicId, topicName }) => ({
    label: topicName,
    value: topicId
  }),
  [AUTO_GENERATED_TYPES.TAG]: ({ tagId, tagName }) => ({
    label: tagName,
    value: tagId
  }),
  [AUTO_GENERATED_TYPES.COLLECTION]: ({ collectionId, collectionTitle }) => ({
    label: collectionTitle,
    value: collectionId
  })
};

export const MAX_LENGTHS = {
  TITLE: 255,
  DESCRIPTION: 1000,
  NAME: 50,
  CTA: 25,
  KEY: 25,
  PHONE_NUMBER: 20,
  FORM_INPUT: 100
};

export const ASSET_TYPE = {
  IMAGE: 'Image',
  VIDEO: 'Video',
  TEXT: 'Text',
  AUDIO: 'Audio',
  DOCUMENT: 'Document',
  ICON: 'Icon'
};

export const WORKSPACE_ROLE_PERMISSION = {
  ASSET_MANAGEMENT: 'ASSET_MANAGEMENT', // assets
  LABEL_MANAGEMENT: 'LABEL_MANAGEMENT', // labels
  CONTENT_MANAGEMENT: 'CONTENT_MANAGEMENT', // content units
  PAGE_MANAGEMENT: 'PAGE_MANAGEMENT', // pages
  USER_MANAGEMENT: 'USER_MANAGEMENT', // users , donations
  APP_MANAGEMENT: 'APP_MANAGEMENT', // app
  ROLE_MANAGEMENT: 'ROLE_MANAGEMENT', // roles
  WORKSPACE_USER_MANAGEMENT: 'WORKSPACE_USER_MANAGEMENT', // workspace users
  REPORT_MANAGEMENT: 'REPORT_MANAGEMENT', // reports
  PLATFORM_MANAGEMENT: 'PLATFORM_MANAGEMENT', // platforms
  UI_CONFIG_MANAGEMENT: 'UI_CONFIG_MANAGEMENT', // menus and ui labels
  SUBSCRIPTION_MANAGEMENT: 'SUBSCRIPTION_MANAGEMENT' // subscription plans
};

export const WORKSPACE_ROLE_LEVEL = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  NONE: 'NONE'
};

export const PERMISSIONS = {
  NONE: {
    label: 'No Access',
    order: 1,
    isActive: true,
    isDefault: false
  },
  VIEW: {
    label: 'View',
    order: 2,
    isActive: true,
    isDefault: true
  },
  EDIT: {
    label: 'Add/Edit',
    order: 3,
    isActive: true,
    isDefault: false
  },
  DELETE: {
    label: 'Full Access',
    order: 4,
    isActive: true,
    isDefault: false
  }
};
export const PROVIDER_TYPES = {
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  STORAGE: 'STORAGE',
  EMAIL: 'EMAIL',
  AUTHENTICATION: 'AUTHENTICATION',
  PUSH_NOTIFICATION: 'PUSH_NOTIFICATION',
  PAYMENT: 'PAYMENT',
  SMS: 'SMS',
  SMS_OTP: 'SMS_OTP',
  USER_VIDEO: 'USER_VIDEO',
  USER_AUDIO: 'USER_AUDIO'
};

export const PROVIDER_TYPES_OPTIONS = [
  { label: 'Authentication', value: PROVIDER_TYPES.AUTHENTICATION },
  { label: 'Storage', value: PROVIDER_TYPES.STORAGE },
  { label: 'Video', value: PROVIDER_TYPES.VIDEO },
  { label: 'Audio', value: PROVIDER_TYPES.AUDIO },
  { label: 'Email', value: PROVIDER_TYPES.EMAIL },
  { label: 'Payment', value: PROVIDER_TYPES.PAYMENT },
  { label: 'SMS', value: PROVIDER_TYPES.SMS },
  { label: 'OTP', value: PROVIDER_TYPES.SMS_OTP },
  { label: 'User Video', value: PROVIDER_TYPES.USER_VIDEO },
  { label: 'User Audio', value: PROVIDER_TYPES.USER_AUDIO },
  { label: 'Push Notification', value: PROVIDER_TYPES.PUSH_NOTIFICATION }
];

export const VIDEO_UPLOAD_PLATFORMS = {
  BRIGHTCOVE: 'BRIGHTCOVE',
  BUNNY_STREAM: 'BUNNY_STREAM',
  MUX: 'MUX',
  PEERTUBE: 'PEERTUBE'
};

export const AUDIO_UPLOAD_PLATFORMS = {
  PEERTUBE: 'PEERTUBE'
};

export const PERMISSION_ROUTES = {
  ASSET_MANAGEMENT: ROUTES.IMAGES,
  LABEL_MANAGEMENT: ROUTES.TOPICS,
  CONTENT_MANAGEMENT: ROUTES.VIDEOS_MODULE,
  PAGE_MANAGEMENT: ROUTES.PAGES_MODULE,
  USER_MANAGEMENT: ROUTES.USERS,
  ROLE_MANAGEMENT: ROUTES.ROLES,
  PLATFORM_MANAGEMENT: ROUTES.PLATFORMS,
  UI_CONFIG_MANAGEMENT: ROUTES.MENUS
};

export const PERMISSIONS_ORDER = {
  CONTENT_MANAGEMENT: 1,
  ASSET_MANAGEMENT: 2,
  LABEL_MANAGEMENT: 3,
  PLATFORM_MANAGEMENT: 4,
  USER_MANAGEMENT: 5,
  ROLE_MANAGEMENT: 6,
  WORKSPACE_USER_MANAGEMENT: 7,
  REPORT_MANAGEMENT: 8,
  UI_CONFIG_MANAGEMENT: 9,
  PAGE_MANAGEMENT: 10
};

export const STATIC_DATA_KEYS = {
  MENU: 'menu-data',
  UI_LABELS: 'ui-labels-data',
  CONFIGS: 'configs-data'
};

export const CTA_ACTION_TYPES = [
  {
    label: 'External',
    value: 'EXTERNAL'
  },
  {
    label: 'Submit',
    value: 'SUBMIT'
  }
];

export const DEFAULT_WEB_COLORS = {
  neutral0: '#fff8e8',
  neutral100: '#fff6e6',
  neutral200: '#fef3e3',
  neutral300: '#fcf1e1',
  neutral400: '#f9eede',
  neutral500: '#7f7f7f',
  neutral600: '#666666',
  neutral700: '#4c4c4c',
  neutral800: '#333333',
  neutral900: '#191919',
  neutral1000: '#000000',
  footerBg: '#000000',
  ivory: '#f9eede',
  white90: '#eeeeee',
  white80: '#ebebeb',
  white70: '#e9e9e9',
  black90: '#1a1a1a',
  black80: '#333333',
  black70: '#4d4d4d',
  red: '#ff7b4c',
  red2: '#fe4819',
  red3: '#b02501',
  yellow: '#ffe546',
  yellow2: '#f4b213',
  yellow3: '#9a6f07',
  blue: '#e1fdff',
  blue2: '#aecacd',
  blue3: '#6fa1a6',
  moss: '#d7c895',
  moss2: '#a49562',
  moss3: '#655c3b',
  borderDark: '#ddd3c5',
  borderLight: '#e9e9e9'
};

export const COLLECTION_ITEM_TYPES = [
  {
    label: 'Video',
    value: 'VIDEO'
  },
  {
    label: 'Podcast',
    value: 'PODCAST'
  },
  {
    label: 'Form',
    value: 'FORM'
  }
];

export const LOGO_SIZES = {
  SMALL: 'SMALL',
  MEDIUM: 'MEDIUM',
  LARGE: 'LARGE'
};

export const LOGO_SIZES_OPTIONS = [
  { label: 'Small', value: LOGO_SIZES.SMALL },
  { label: 'Medium', value: LOGO_SIZES.MEDIUM },
  { label: 'Large', value: LOGO_SIZES.LARGE }
];

export const LOGO_POSITIONS = {
  LEFT: 'LEFT',
  CENTER: 'CENTER',
  RIGHT: 'RIGHT'
};

export const LOGO_POSITIONS_OPTIONS = [
  { label: 'Left', value: LOGO_POSITIONS.LEFT },
  { label: 'Middle', value: LOGO_POSITIONS.CENTER },
  { label: 'Right', value: LOGO_POSITIONS.RIGHT }
];

export const SHOW_MENU = {
  YES: 'YES',
  NO: 'NO'
};

export const SHOW_MENU_OPTIONS = [
  { label: 'Yes', value: SHOW_MENU.YES },
  { label: 'No', value: SHOW_MENU.NO }
];

export const LIVE_VIDEO_STATUS = {
  ON: 'on',
  OFF: 'off'
};

export const DOMAIN_STATUS = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  ERRORED: 'ERRORED',
  VERIFICATION_PENDING: 'VERIFICATION_PENDING'
};

export const PLAN_FREQUENCY_OPTIONS = [
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Annually', value: 'ANNUALLY' }
];

export const PLAN_TYPE_KEYS = {
  ONE_TIME: 'ONE_TIME',
  RECURRING: 'RECURRING'
};

export const PLAN_TYPE_OPTIONS = [
  { label: 'One Time', value: PLAN_TYPE_KEYS.ONE_TIME },
  { label: 'Recurring', value: PLAN_TYPE_KEYS.RECURRING }
];

export const TRIAL_PERIOD_UNIT_OPTIONS = [{ label: 'Days', value: 'DAY' }];

export const UI_LABEL_TYPE = [
  { label: 'UI', value: 'UI' },
  { label: 'Message', value: 'MESSAGE' }
];

export const PERMISSION_TYPE = {
  READ: 'READ',
  WRITE: 'WRITE'
};

export const FORM_TYPES = {
  CONTACT_US: 'CONTACT_US',
  OTHER: 'OTHER'
};

export const FORM_TYPE_OPTIONS = [
  {
    label: 'Contact Us',
    value: FORM_TYPES.CONTACT_US
  },
  {
    label: 'Other',
    value: FORM_TYPES.OTHER
  }
];

export const FORM_CTA_TYPES = [
  {
    label: 'Primary',
    value: 'PRIMARY'
  },
  {
    label: 'Secondary',
    value: 'SECONDARY'
  }
];

export const FORM_MESSAGE_TYPES = [
  {
    label: 'Submitted',
    value: 'SUBMITTED'
  },
  {
    label: 'Success',
    value: 'SUCCESS'
  },
  {
    label: 'Failed',
    value: 'FAILED'
  }
];

export const FORM_FIELD_TYPES = [
  {
    label: 'String',
    value: 'string'
  },
  {
    label: 'Text',
    value: 'text'
  },
  {
    label: 'Number',
    value: 'number'
  },
  {
    label: 'Email',
    value: 'email'
  },
  {
    label: 'Dropdown',
    value: 'dropdown'
  }
];

export const TIME_PERIOD = {
  ONE_MINUTE: 60000
};

export const AUTO_ADVANCE_DEFAULTS = {
  INTERVAL: 6,
  RESUME_DELAY: 10,
  MIN_INTERVAL: 1,
  MAX_INTERVAL: 60,
  MIN_RESUME_DELAY: 1,
  MAX_RESUME_DELAY: 60
};

export const IMPORT_JOBS_STATIC_FILES_URL = {
  [EXPORT_JOB_TYPES.USER]: 'users.csv',
  [EXPORT_JOB_TYPES.UI_LABEL]: 'ui-labels.csv'
};

export const PLAN_TYPE = {
  FREE: 'FREE',
  FREE_TRIAL: 'FREE_TRIAL',
  GUEST: 'GUEST'
};

export const TIME_FORMATS = {
  TIME_FORMAT_12H_LOWER: 'h:mm a',
  TIME_FORMAT_12H_UPPER: 'h:mm A',
  TIME_FORMAT_24H: 'HH:mm',
  CUSTOM_TIME_FORMAT: 'g:i a',
  TIME_WITH_TIMEZONE_FORMAT: 'hh:mm a (z)'
};

export const VIDEO_LIVE_STATUS = {
  PENDING: 'PENDING',
  LIVE: 'LIVE',
  PAUSED: 'PAUSED',
  COMPLETED: 'COMPLETED',
  VOD_PROCESSING: 'VOD_PROCESSING',
  VOD_READY: 'VOD_READY'
};

export const VIDEO_LIVE_STATUS_OPTIONS = [
  { label: 'Pending', value: VIDEO_LIVE_STATUS.PENDING },
  { label: 'Live', value: VIDEO_LIVE_STATUS.LIVE },
  { label: 'Paused', value: VIDEO_LIVE_STATUS.PAUSED },
  { label: 'Completed', value: VIDEO_LIVE_STATUS.COMPLETED },
  { label: 'VOD Processing', value: VIDEO_LIVE_STATUS.VOD_PROCESSING },
  { label: 'VOD Ready', value: VIDEO_LIVE_STATUS.VOD_READY }
];

export const LIVE_STATUS_COLORS = {
  [VIDEO_LIVE_STATUS.PENDING]: '#1890ff',
  [VIDEO_LIVE_STATUS.LIVE]: '#ff4d4f',
  [VIDEO_LIVE_STATUS.PAUSED]: '#faad14',
  [VIDEO_LIVE_STATUS.COMPLETED]: '#52c41a',
  [VIDEO_LIVE_STATUS.VOD_PROCESSING]: '#fa8c16',
  [VIDEO_LIVE_STATUS.VOD_READY]: '#52c41a'
};
